import { IAppPayload, IState } from '../types';

export function appStateReducer(state: IState, action: { value: IAppPayload }): IState {
  const {
    deviceType,
    platform,
    userId,
    equipmentType,
    userType,
    doEnableScaling,
    token,
    clientId,
    clientSecret,
    date,
    language,
    baseGatewayAPIUrl,
    useMetricUnits,
    softwareNumber,
    isEmbedded,
    appVersion,
    rawPayload,
    supportsDeepLinksV1,
    featureFlags,
  } = action.value;

  return {
    ...state,
    deviceType,
    platform,
    softwareNumber,
    userId,
    equipmentType,
    userType,
    doEnableScaling: doEnableScaling === 'true',
    token,
    clientId,
    clientSecret,
    date,
    language: language || 'en',
    baseGatewayAPIUrl,
    useMetricUnits,
    isEmbedded,
    appVersion,
    rawPayload,
    supportsDeepLinksV1,
    featureFlags,
  };
}
